module.exports = {
  entry: './src/apps/dora-assessment/index.tsx',
  shortcode: 'dora-assessment',
  title: 'DORA assessment',
  status: 'stable',
  description:
    'IBM Security & Resilience Assessment which was completed in collaboration between the Storage and Security teams of CLIENT and the IBM Client Engineering team is a report designed to help the client leverage effective systems and processes that provide valuable insight into information and events that occur within an environment and provide the confidence for orchestrated security and resilience processes to not disrupt business continuity objectives.',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-dora-assessment-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/cloud', '/products', '/flashsystem'],
    availableTranslations: [
      'de',
      'en',
      'es',
      'esla',
      'fr',
      'it',
      'ja',
      'ko',
      'pt',
      'zh-cn',
    ],
  },
};
